import BaseListPresenter from "../../../../base/BaseListPresenter";
import { getCurrentUserUseCase } from "../../../../usecases/user";
import {
  format,
  startOfDay,
  addHours,
  addMinutes,
  addDays,
  parseISO,
} from "date-fns";

class TransTypeDistributionPresenter extends BaseListPresenter {
  init() {
    this.store = [];
    this.limit = 50000;
    this.where = {};
    this.search = {};
    this.filter = {};
    this.filterDate = {};
    this.filterStore = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }
  async findObjects() {
    // 1) Load user + store (kailangan bago gumawa ng whereClause)
    try {
      const user = await getCurrentUserUseCase().execute();
      const storeQuery = { include: ["all"], where: { email: user.email } };
      this.store = await this.findObjectUseCase.execute("users", storeQuery);

      const store = (this.store?.[0]?.storeAnalytic ?? []).sort((a, b) =>
        a.name.toUpperCase().localeCompare(b.name.toUpperCase())
      );
      this.view.setStore(store);
    } catch (error) {
      console.error("Error fetching user or store data:", error);
      return;
    }

    // 2) Build base filters (AllStore -> $in ng lahat ng analytic names)
    const storeCodes =
      this.store?.[0]?.storeAnalytic?.map((a) => a?.name).filter(Boolean) ?? [];

    const whereClause = {
      ...this.filterDate,
      store_code:
        this.filterStore === "AllStore"
          ? { $in: storeCodes }
          : this.filterStore,
    };

    // fixed: true batching size
    const pageSize = this.limit || 50000;

    // 3) Count muna gamit ang full filter
    let totalCount = 0;
    try {
      this.showProgress();
      this.findObjectUseCase.abort(); // cancel any in-flight

      const { count } = await this.countObjectUseCase.execute(
        this.view.getCollectionName(),
        { where: whereClause }
      );

      totalCount = count ?? 0;
      this.count = totalCount;
      this.view.setCount(totalCount);

      // Reset UI state
      this.objects = [];
      this.view.setObjects([]);
      this.view.setTotal(0);
      this.view.setNotFound(false);

      // Not-found delay (optional)
      let timeoutId = null;
      if (totalCount === 0) {
        timeoutId = setTimeout(() => {
          if (this.objects.length === 0) {
            console.log("No data after delay. Setting NotFound = true");
            this.view.setNotFound(true);
          }
        }, 30000);
        // Walang data — wala nang ipe-fetch na pages
        if (timeoutId) clearTimeout(timeoutId);
        return;
      }

      // 4) Batch pagination loop
      let fetched = 0;
      let page = 0;

      // Shared buffer + periodic flush (para smooth ang UI)
      let buffer = [];
      const flushBuffer = () => {
        if (buffer.length === 0) return;
        this.objects = this.objects.concat(buffer);
        this.view.setObjects(this.objects);
        this.view.setTotal(this.objects.length);
        buffer = [];
      };
      const flushInterval = setInterval(flushBuffer, 1000);

      try {
        while (fetched < totalCount) {
          const skip = page * pageSize;

          const query = {
            skip,
            limit: pageSize, // <<— important: 20 per batch
            where: whereClause,
            include: ["all"],
            sort: this.sort,
            keys: [
              "store_code",
              "tran_date",
              "total",
              "total_taxfree",
              "total_tax",
              "discount_amount",
              "createdAt",
              "cust_name",
              "tran_type",
              "paymenttype",
              "cust_count",
              "total_pretax",
              "status",
            ],
          };

          // Per-page local buffer via onData
          let pageRowCount = 0;
          const onData = (objects) => {
            if (objects?.length) {
              buffer.push(...objects);
              pageRowCount += objects.length;
            }
          };

          // Execute one page (may stream sa loob, pero hanggang `limit` lang)
          await this.findObjectUseCase.execute(
            this.view.getCollectionName(),
            query,
            { timeout: 120000, onData }
          );

          // Push whatever came in this page
          flushBuffer();

          // Walang dumating sa page na ito → tapos na
          if (pageRowCount === 0) break;

          fetched += pageRowCount;
          page += 1;

          // Yield para hindi ma-block UI thread
          await Promise.resolve();
        }
      } finally {
        clearInterval(flushInterval);
        flushBuffer();
      }

      // Safeguard
      if (this.objects.length === 0) {
        this.view.setNotFound(true);
      }
    } catch (error) {
      console.error("Error fetching objects:", error);
      this.view.showError(error);
    } finally {
      this.hideProgress();
      this.progress = false;
    }
  }
  // async findObjects() {
  //   // Fetch the current user and store information
  //   try {
  //     const user = await getCurrentUserUseCase().execute();
  //     const storeQuery = {
  //       include: ["all"],
  //       where: { email: user.email },
  //     };
  //     this.store = await this.findObjectUseCase.execute("users", storeQuery);
  //     // const store = this.store[0].storeAnalytic;
  //     const store = this.store[0].storeAnalytic.sort((a, b) => {
  //       const nameA = a.name.toUpperCase(); // ignore upper and lowercase
  //       const nameB = b.name.toUpperCase(); // ignore upper and lowercase
  //       if (nameA < nameB) {
  //         return -1;
  //       }
  //       if (nameA > nameB) {
  //         return 1;
  //       }
  //       return 0; // names must be equal
  //     });
  //     this.view.setStore(store);
  //   } catch (error) {
  //     console.error("Error fetching user or store data:", error);
  //     return; // Exit if there's an error fetching user or store data
  //   }

  //   // Prepare the query for finding objects
  //   const skip = (this.current - 1) * this.limit;
  //   const storeCodes = this.store?.flatMap((storeItem) =>
  //     storeItem.storeAnalytic?.map((analytic) => analytic?.name)
  //   );

  //   const query = {
  //     limit: this.limit,
  //     skip: skip,
  //     where: {
  //       store_code:
  //         this.filterStore === "AllStore" ? storeCodes : this.filterStore,
  //       ...this.filterDate,
  //     },
  //     include: ["all"],
  //     sort: this.sort,
  //     keys: [
  //       "store_code",
  //       "tran_date",
  //       "total",
  //       "total_taxfree",
  //       "total_tax",
  //       "discount_amount",
  //       "createdAt",
  //       "cust_name",
  //       "tran_type",
  //       "paymenttype",
  //       "cust_count",
  //       "status",
  //       // "items",
  //     ],
  //   };

  //   // Execute the query and update the view
  //   try {
  //     this.showProgress();
  //     this.findObjectUseCase.abort(); // Abort any previous use case execution
  //     // const objects = await this.findObjectUseCase.execute(
  //     //   this.view.getCollectionName(),
  //     //   query
  //     // );
  //     if (Object.keys(this.filterDate).length === 0) {
  //       console.log("data");
  //     } else {
  //       const { count } = await this.countObjectUseCase.execute(
  //         this.view.getCollectionName(),
  //         { where: query.where }
  //       );

  //       this.count = count;
  //       console.log("this.count", this.count);
  //       this.view.setCount(this.count);

  //       let timeoutId = null;

  //       // Handle delayed "not found"
  //       if (this.count === 0) {
  //         timeoutId = setTimeout(() => {
  //           if (this.count === 0) {
  //             this.view.setNotFound(true);
  //             this.view.setObjects([]);
  //             this.view.setTotal(0);
  //           }
  //         }, 15000); // 15 seconds delay
  //       }

  //       // Batching logic
  //       let buffer = [];

  //       const flushBuffer = () => {
  //         if (buffer.length > 0) {
  //           this.view.setState((prevState) => ({
  //             objects: [...prevState.objects, ...buffer],
  //           }));
  //           this.objects = this.objects.concat(buffer);
  //           this.view.setTotal(this.objects.length);
  //           this.view.setObjects(this.objects);
  //           buffer = [];
  //         }
  //       };

  //       const onData = (objects) => {
  //         if (objects.length > 0 && timeoutId) {
  //           clearTimeout(timeoutId);
  //           timeoutId = null;
  //           this.view.setNotFound(false);
  //         }
  //         buffer.push(...objects);
  //       };

  //       const flushInterval = setInterval(flushBuffer, 2000);

  //       await this.findObjectUseCase.execute(
  //         this.view.getCollectionName(),
  //         query,
  //         {
  //           timeout: 100000,
  //           onData,
  //         }
  //       );

  //       clearInterval(flushInterval);
  //       flushBuffer();
  //       // this.objects = this.objects.concat(objects);
  //       // this.view.setTotal(this.objects.length);
  //       // this.view.setObjects(this.objects);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching objects:", error);
  //     this.view.showError(error);
  //   } finally {
  //     this.hideProgress();
  //     this.progress = false;
  //   }
  // }
  onChangeStore(where) {
    this.filterStore = where;
    this.getObjects();
  }

  // onChangeDate(where) {
  //   this.filterDate = where;
  //   this.getObjects();
  // }
  // onChangeDate(where) {
  //   const { tran_date } = where;
  //   console.log("tran", tran_date);

  //   if (tran_date && tran_date.$gte && tran_date.$lte) {
  //     const startDate = addHours(startOfDay(parseISO(tran_date.$gte)), 5);
  //     const endDate = addMinutes(addHours(addDays(startDate, 1), -1), 59);

  //     const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
  //     const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

  //     this.filterDate = {
  //       tran_date: {
  //         $gte: formattedStartDate,
  //         $lte: formattedEndDate,
  //       },
  //     };
  //   }

  //   console.log("date", this.filterDate);
  //   this.getObjects();
  // }
  onChangeDate(where) {
    const { tran_date } = where;
    console.log("tran", tran_date);

    if (tran_date && tran_date.$gte && tran_date.$lte) {
      const startDate = addHours(startOfDay(parseISO(tran_date.$gte)), 5);
      const endDate = addMinutes(
        addHours(addDays(startOfDay(parseISO(tran_date.$lte)), 0), 4),
        59
      );

      const formattedStartDate = format(startDate, "yyyy-MM-dd HH:mm:ss.SSS");
      const formattedEndDate = format(endDate, "yyyy-MM-dd HH:mm:ss.SSS");

      this.filterDate = {
        tran_date: {
          $gte: formattedStartDate,
          $lte: formattedEndDate,
        },
      };
    }

    console.log("date", this.filterDate);
    this.getObjects();
  }
}

export default TransTypeDistributionPresenter;
